import { defineMessages } from 'react-intl';

// we have no autocomplete here?
// because of defineMessages?

const placeholders = defineMessages({
    // VEHICLE
    vin: {
        id: 'PLACEHOLDER_VIN',
    },
    mileage: {
        id: 'PLACEHOLDER_MILEAGE',
    },
    licensePlate: {
        id: 'PLACEHOLDER_LICENSE_PLATE',
    },
    monthYearDatePicker: {
        id: 'PLACEHOLDER_MONTH_YEAR_DATEPICKER'
    },

    // ACCOUNT DETAILS
    firstName: {
        id: 'PLACEHOLDER_FIRST_NAME',
    },
    lastName: {
        id: 'PLACEHOLDER_LAST_NAME',
    },
    email: {
        id: 'PLACEHOLDER_EMAIL',
    },
    phone: {
        id: 'PLACEHOLDER_PHONE',
    },
    password: {
        id: 'PLACEHOLDER_PASSWORD',
    },
    country: {
        id: 'COUNTRY',
    },
    belgium: {
        id: 'BELGIUM',
    },
    netherlands: {
        id: 'NETHERLANDS',
    },

    // COMPANY DETAILS
    vatNumber: {
        id: 'PLACEHOLDER_VAT_NUMBER',
    },
    companyName: {
        id: 'PLACEHOLDER_COMPANY_NAME',
    },
    street: {
        id: 'PLACEHOLDER_STREET',
    },
    houseNumber: {
        id: 'PLACEHOLDER_HOUSE_NUMBER',
    },
    city: {
        id: 'PLACEHOLDER_CITY',
    },
    postalCode: {
        id: 'PLACEHOLDER_POSTAL_CODE',
    },
    accountNumber: {
        id: 'ACCOUNT_NUMBER',
    },
    chooseIndustry: {
        id: 'PLACEHOLDER_CHOOSE_INDUSTRY'
    },

    // CARD DETAILS
    cardNumber: {
        id: 'PLACEHOLDER_CARD_NUMBER',
    },
    cardExpireDate: {
        id: 'PLACEHOLDER_CARD_EXPIRE_DATE',
    },
    cardCVC: {
        id: 'PLACEHOLDER_CARD_CVC',
    },

    // CHOOSE CONNECTION
    chooseService: {
        id: 'PLACEHOLDER_CHOOSE_SERVICE',
    },
    choose: {
        id: 'PLACEHOLDER_CHOOSE'
    },

    // VEHICLES
    licensePlates: {
        id: 'PLACEHOLDER_LICENSE_PLATES',
    },
    status: {
        id: 'STATUS',
    },
    group: {
        id: 'GROUP',
    },
    active: {
        id: 'STATUS_ACTIVE',
    },
    noDevice: {
        id: 'STATUS_NO_DEVICE',
    },
    issue: {
        id: 'STATUS_ISSUE',
    },
    ready: {
        id: 'STATUS_READY',
    },

    // LANGUAGES ------------------------------
    en: {
        id: 'LANGUAGE_EN',
    },
    nl: {
        id: 'LANGUAGE_NL_NL',
    },
    'nl-BE': {
        id: 'LANGUAGE_NL_BE',
    },
    fr: {
        id: 'LANGUAGE_FR'
    },

    // -----------------------------------------

    parkdTermsConditionsURL: {
        id: 'REGISTRATION_TERMS_URL',
    },

    // FILTER
    loading: {
        id: 'GLOBAL_LOADING',
    },

    // REACT TABLE SEARCH INPUT PLACEHOLDERS + global
    search: {
        id: 'PLACEHOLDER_SEARCH',
    },

    //----------------------------
});


export default placeholders;